import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Rataopasteet — Frisbeegolfradat' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Radat"
			title="Rataopasteet"
			intro="Parkdly-väyläopasteet ratojen ammattimaiseen hallintaan."
			note="Mainossisältö tulossa. Tämä on Parkdly-kumppanuuden esittelysivu."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
